import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-low-stock-chart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './low-stock-chart.component.html',
  styleUrl: './low-stock-chart.component.scss'
})
export class LowStockChartComponent {
  @Input() isLoadingLowStock: boolean = false;
  @Input() lowStockData: any[] = [];
} 